/* eslint-disable no-nested-ternary */
import { CloseCircleOutlined } from '@ant-design/icons';
import PropType from 'prop-types';
import React from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { applyFilter } from 'redux/actions/filterActions';
import { useTranslation } from 'react-i18next';
import firebase from '../../firebase/firebase';

const ProductAppliedFilters = ({ filteredProductsCount }) => {
  const { t } = useTranslation();
  const filter = useSelector((state) => state.filter, shallowEqual);
  const fields = [
    'year',
    'assisted',
    'brand',
    'size',
    'weight',
    'wheels',
    'sub1',
    'type',
    'npa',
    'region',
    'province',
    'minPrice',
    'maxPrice',
    'sortBy',
    'keyword'
  ];
  const isFiltered = fields.some((key) => !!filter[key]);
  const dispatch = useDispatch();

  const onRemoveKeywordFilter = () => {
    dispatch(applyFilter({ keyword: '' }));
  };

  const onRemovePriceRangeFilter = () => {
    dispatch(applyFilter({ minPrice: 0, maxPrice: 0 }));
  };

  const onRemoveSortFilter = () => {
    dispatch(applyFilter({ sortBy: '' }));
  };

  const onRemoveRegionFilter = () => {
    dispatch(applyFilter({ region: '', province: '' }));
  };

  const onRemoveProvinceFilter = () => {
    dispatch(applyFilter({ province: '' }));
  };

  const onRemoveNpaFilter = () => {
    dispatch(applyFilter({ npa: '' }));
  };

  const onRemoveTypeFilter = () => {
    dispatch(
      applyFilter({
        type: '',
        sub1: '',
        year: '',
        brand: '',
        assisted: '',
        weight: '',
        size: '',
        wheels: ''
      })
    );
  };

  const onRemoveSub1Filter = () => {
    dispatch(applyFilter({ sub1: '' }));
  };

  const onRemoveYearFilter = () => {
    dispatch(applyFilter({ year: '' }));
  };

  const onRemoveBrandFilter = () => {
    dispatch(applyFilter({ brand: '' }));
  };

  const onRemoveAssistedFilter = () => {
    dispatch(applyFilter({ assisted: '' }));
  };

  const onRemoveSizeFilter = () => {
    dispatch(applyFilter({ size: '' }));
  };

  const onRemoveWheelsFilter = () => {
    dispatch(applyFilter({ wheels: '' }));
  };

  const onRemoveWeightFilter = () => {
    dispatch(applyFilter({ weight: '' }));
  };

  return !isFiltered ? null : (
    <>
      <div className="product-list-header">
        <div className="product-list-header-title">
          <h5>
            {filteredProductsCount > 0 &&
              `${filteredProductsCount} ${
                filteredProductsCount > 1
                  ? t('menuFilterMultipleResults')
                  : t('menuFilterSingleResult')
              }`}
          </h5>
        </div>
      </div>
      <div className="product-applied-filters">
        {filter.keyword && (
          <div className="pill-wrapper">
            <span className="d-block">Keyword</span>
            <div className="pill padding-right-l">
              <h5 className="pill-content margin-0">{filter.keyword}</h5>
              <div
                className="pill-remove"
                onClick={onRemoveKeywordFilter}
                role="presentation"
              >
                <h5 className="margin-0 text-subtle">
                  <CloseCircleOutlined />
                </h5>
              </div>
            </div>
          </div>
        )}
        {(!!filter.minPrice || !!filter.maxPrice) && (
          <div className="pill-wrapper">
            <span className="d-block">{t('menuFilterPrice')}</span>
            <div className="pill padding-right-l">
              <h5 className="pill-content margin-0">
                {filter.minPrice} {firebase.clientCurrency} - {filter.maxPrice}{' '}
                {firebase.clientCurrency}
              </h5>
              <div
                className="pill-remove"
                onClick={onRemovePriceRangeFilter}
                role="presentation"
              >
                <h5 className="margin-0 text-subtle">
                  <CloseCircleOutlined />
                </h5>
              </div>
            </div>
          </div>
        )}
        {filter.sortBy && (
          <div className="pill-wrapper">
            <span className="d-block">{t('menuFilterOrder')}</span>
            <div className="pill padding-right-l">
              <h5 className="pill-content margin-0">
                {filter.sortBy === 'price-desc'
                  ? t('menuFilterOrderPriceDesc')
                  : filter.sortBy === 'price-asc'
                  ? t('menuFilterOrderPriceAsc')
                  : filter.sortBy === 'name-desc'
                  ? t('menuFilterOrderNameDesc')
                  : filter.sortBy === 'name-asc'
                  ? t('menuFilterOrderNameAsc')
                  : filter.sortBy === 'date-desc'
                  ? t('menuFilterOrderDateDesc')
                  : t('menuFilterOrderDateAsc')}
              </h5>
              <div
                className="pill-remove"
                onClick={onRemoveSortFilter}
                role="presentation"
              >
                <h5 className="margin-0 text-subtle">
                  <CloseCircleOutlined />
                </h5>
              </div>
            </div>
          </div>
        )}
        {filter.type && (
          <div className="pill-wrapper">
            <span className="d-block">{t('productFormType')}</span>
            <div className="pill padding-right-l">
              <h5 className="pill-content margin-0">
                {filter.type === 'Bicicletta'
                  ? t('productFormBike')
                  : t('productFormAccessory')}
              </h5>
              <div
                className="pill-remove"
                onClick={onRemoveTypeFilter}
                role="presentation"
              >
                <h5 className="margin-0 text-subtle">
                  <CloseCircleOutlined />
                </h5>
              </div>
            </div>
          </div>
        )}
        {filter.sub1 && (
          <div className="pill-wrapper">
            <span className="d-block">{t('productFormSub')}</span>
            <div className="pill padding-right-l">
              <h5 className="pill-content margin-0">
                {filter.sub1 === 'Strada'
                  ? t('productFormStreet')
                  : filter.sub1}
              </h5>
              <div
                className="pill-remove"
                onClick={onRemoveSub1Filter}
                role="presentation"
              >
                <h5 className="margin-0 text-subtle">
                  <CloseCircleOutlined />
                </h5>
              </div>
            </div>
          </div>
        )}
        {filter.year && (
          <div className="pill-wrapper">
            <span className="d-block">{t('productFormYear')}</span>
            <div className="pill padding-right-l">
              <h5 className="pill-content margin-0">{filter.year}</h5>
              <div
                className="pill-remove"
                onClick={onRemoveYearFilter}
                role="presentation"
              >
                <h5 className="margin-0 text-subtle">
                  <CloseCircleOutlined />
                </h5>
              </div>
            </div>
          </div>
        )}
        {filter.size && (
          <div className="pill-wrapper">
            <span className="d-block">{t('productFormSize')}</span>
            <div className="pill padding-right-l">
              <h5 className="pill-content margin-0">{filter.size}</h5>
              <div
                className="pill-remove"
                onClick={onRemoveSizeFilter}
                role="presentation"
              >
                <h5 className="margin-0 text-subtle">
                  <CloseCircleOutlined />
                </h5>
              </div>
            </div>
          </div>
        )}
        {filter.brand && (
          <div className="pill-wrapper">
            <span className="d-block">{t('productFormBrand')}</span>
            <div className="pill padding-right-l">
              <h5 className="pill-content margin-0">{filter.brand}</h5>
              <div
                className="pill-remove"
                onClick={onRemoveBrandFilter}
                role="presentation"
              >
                <h5 className="margin-0 text-subtle">
                  <CloseCircleOutlined />
                </h5>
              </div>
            </div>
          </div>
        )}
        {filter.assisted && (
          <div className="pill-wrapper">
            <span className="d-block">{t('productFormPedaling')}</span>
            <div className="pill padding-right-l">
              <h5 className="pill-content margin-0">
                {filter.assisted === 'Assistita'
                  ? t('productFormAssisted')
                  : t('productFormNotAssisted')}
              </h5>
              <div
                className="pill-remove"
                onClick={onRemoveAssistedFilter}
                role="presentation"
              >
                <h5 className="margin-0 text-subtle">
                  <CloseCircleOutlined />
                </h5>
              </div>
            </div>
          </div>
        )}
        {filter.weight && (
          <div className="pill-wrapper">
            <span className="d-block">{t('productFormWeight')}</span>
            <div className="pill padding-right-l">
              <h5 className="pill-content margin-0">{`${filter.weight} Kg`}</h5>
              <div
                className="pill-remove"
                onClick={onRemoveWeightFilter}
                role="presentation"
              >
                <h5 className="margin-0 text-subtle">
                  <CloseCircleOutlined />
                </h5>
              </div>
            </div>
          </div>
        )}
        {filter.wheels && (
          <div className="pill-wrapper">
            <span className="d-block">{t('productFormWheels')}</span>
            <div className="pill padding-right-l">
              <h5 className="pill-content margin-0">{filter.wheels}&#34;</h5>
              <div
                className="pill-remove"
                onClick={onRemoveWheelsFilter}
                role="presentation"
              >
                <h5 className="margin-0 text-subtle">
                  <CloseCircleOutlined />
                </h5>
              </div>
            </div>
          </div>
        )}
        {filter.region && (
          <div className="pill-wrapper">
            <span className="d-block">{t('menuFilterRegion')}</span>
            <div className="pill padding-right-l">
              <h5 className="pill-content margin-0">{filter.region}</h5>
              <div
                className="pill-remove"
                onClick={onRemoveRegionFilter}
                role="presentation"
              >
                <h5 className="margin-0 text-subtle">
                  <CloseCircleOutlined />
                </h5>
              </div>
            </div>
          </div>
        )}
        {filter.province && (
          <div className="pill-wrapper">
            <span className="d-block">{t('menuFilterProvince')}</span>
            <div className="pill padding-right-l">
              <h5 className="pill-content margin-0">{filter.province}</h5>
              <div
                className="pill-remove"
                onClick={onRemoveProvinceFilter}
                role="presentation"
              >
                <h5 className="margin-0 text-subtle">
                  <CloseCircleOutlined />
                </h5>
              </div>
            </div>
          </div>
        )}
        {filter.npa && (
          <div className="pill-wrapper">
            <span className="d-block">{t('menuFilterNPA')}</span>
            <div className="pill padding-right-l">
              <h5 className="pill-content margin-0">{filter.npa}</h5>
              <div
                className="pill-remove"
                onClick={onRemoveNpaFilter}
                role="presentation"
              >
                <h5 className="margin-0 text-subtle">
                  <CloseCircleOutlined />
                </h5>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

ProductAppliedFilters.defaultProps = {
  filteredProductsCount: 0
};

ProductAppliedFilters.propTypes = {
  filteredProductsCount: PropType.number
};

export default ProductAppliedFilters;
